import "@fontsource/open-sans/300.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/source-sans-pro/400.css";
import "@fontsource/source-sans-pro/600.css";
import { Outlet } from "react-router-dom";

export default function App() {
  return <Outlet />;
}
